import { createContainer } from 'unstated-next'
import Web3 from './web3'

interface useSystemProps {
  currentAccount: string | null | undefined
}

function useSystem(): useSystemProps {
  const { currentAccount } = Web3.useContainer()

  return {
    currentAccount,
  }
}

const System = createContainer(useSystem)

export default System
